import React from 'react';
import {CyClass} from "../../../common/cy-classes";
import {observer} from 'mobx-react';
import {OrbitComponent} from '../base-components/orbit-component/orbit-component';
import {HomePageHeaderArenasBox} from './boxes/home-page-header-arenas-container.box';

export const HomePageHeaderArenasComponent = observer(class HomePageHeaderArenasComponent extends OrbitComponent {

  render() {
    const headerArenas = this.services.homepage.getHeaderArenasMenuItems();

    if (headerArenas.length === 0) {
      return null;
    }

    // Should not render when tabs navigation abtest is on (and the client is on lAndBelow screen)
    // Should not render when homepage arenas hide abtest is on (and the client is on lAndAbove screen)
    if (!this.services.homepage.shouldRenderHeaderArenas) { 
      return null;
    }

    return (
      <HomePageHeaderArenasBox className={CyClass('cy-homepage-header-arenas-container')} headerArenasStyle={this.services.homepage.headerArenasStyle}>
        {headerArenas.map((menuItemRenderer, index) => menuItemRenderer.renderMenuItem({itemIndex: index, totalItemsCount: headerArenas.length}))}
      </HomePageHeaderArenasBox>
    );
  }
});
